import type { KeyboardEvent } from "react";

const TEXT_INPUT_TYPES = new Set(["text", "search", "email", "tel"]);

function isTextInput(element: EventTarget | null): element is HTMLInputElement {
  return element instanceof HTMLInputElement && TEXT_INPUT_TYPES.has(element.type);
}

/**
 * Tasto Invio della tastiera a schermo: passa al campo di testo successivo invece di
 * inviare il form. Sull'ultimo campo chiude la tastiera per liberare lo schermo.
 */
export function focusNextFieldOnEnter(event: KeyboardEvent<HTMLFormElement>) {
  if (event.key !== "Enter" || !isTextInput(event.target)) {
    return;
  }

  event.preventDefault();
  const fields = Array.from(event.currentTarget.querySelectorAll("input")).filter(
    (input) => isTextInput(input) && !input.disabled,
  );
  const nextField = fields[fields.indexOf(event.target) + 1];

  if (nextField) {
    nextField.focus();
  } else {
    event.target.blur();
  }
}

/** Porta in vista il primo errore dopo il render, utile su tablet con form lunghi. */
export function scrollToFirstError(container: HTMLElement | null) {
  window.requestAnimationFrame(() => {
    container
      ?.querySelector(".field__error, .status-banner--error")
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  });
}

/** Porta in vista il passo successivo dopo il render. */
export function scrollToStep(element: HTMLElement | null) {
  window.requestAnimationFrame(() => {
    element?.scrollIntoView({ behavior: "smooth", block: "start" });
  });
}
